import { io, Socket } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET

export const socket: Socket = io(SOCKET_URL);

export const connectSocket = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};